import type { SxProps, Theme } from '@mui/material';
import { Box, styled } from '@mui/material';
const Host = styled(Box)`
  display: inline-block;
  flex-shrink: 0;
  height: 10px;
  width: 10px;

  border-radius: 100%;
`;
export interface BulletProps {
  /** Any CSS colour or palette path, e.g. `text.primary`. Defaults to `primary.main`. */
  color?: string;
  sx?: SxProps<Theme>;
}
export const Bullet = ({
  color,
  sx
}: BulletProps) => {
  return <Host sx={[{
    backgroundColor: color || 'primary.main'
  }, ...(Array.isArray(sx) ? sx : [sx])]} />;
};